import { wayneConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function WayneNJPage() {
  return <CityPageTemplate config={wayneConfig} />;
}